import React, { useContext } from "react";
import { ReactComponent as CloseModal } from "../../assets/close-day.svg";
import { ReactComponent as Logo } from "../../assets/logo-day.svg"; // Add your logo file
import { Link } from "react-router-dom";
import CookieManager from "../../services/CookieManager";
import "./style.css";
import TrackContext from "../../contexts/track-context";

function MobileMenu(props) {
  let userData = JSON.parse(CookieManager.getCookie("user-data"));
  let trackContext = useContext(TrackContext);
  
  const handleMobileSearch = () => {
    props.setShowProjectModal(true);
    props.handleMobileMenuClose();
  };

  const handleSignoutClick = () => {
    trackContext.setShowLogoutPopup(true);
    props.handleMobileMenuClose();
  };

  return (
    <div className="lg:hidden flex flex-col fixed inset-0  overflow-hidden h-screen w-[70%] bg-white text-black">
      {/* Top Section with Logo and Close Button */}
      <div className="flex justify-between items-center px-10 pt-4">
        <Logo className="h-14" /> {/* Adjust height as needed */}
        <CloseModal
          className="cursor-pointer  w-4 h-4"
                    onClick={props.handleMobileMenuClose}
        />
      </div>
      
      {/* Menu Items */}
      <div className="capitalize text-xl ml-10 mt-10">
        {/* <Link to={"/"} onClick={props.handleMobileMenuClose}>
          <div className="mb-4">{process.env.REACT_APP_MKT_SITE_MUSIC_LABEL}</div>
        </Link> */}

      {/* add music key and music ai  */}

<div className="mb-4">
 <Link  to={"/"} onClick={props.handleMobileMenuClose}>
                <span
                 className= "text-xl "
                    
                >
                  {process.env.REACT_APP_MKT_SITE_MUSIC_LABEL}
                </span>
                <sup className='border tag-box rounded-2xl px-1 my-1 text-xs'><b>Key</b></sup>
              </Link>
</div>
      <div className="mb-4">
          <Link to={"/library"} onClick={props.handleMobileMenuClose}>
           <span
                            className={
                           
                                 "text-xl "
                            }
                          >
                            {process.env.REACT_APP_MKT_SITE_MUSIC_LABEL}
                          </span>
                          <sup className='border tag-box rounded-2xl px-2 my-1 text-xs'><b>AI</b></sup>
                        </Link>
                        </div>

        <div className="mb-4">
          <Link
            to={process.env.REACT_APP_MKT_SITE_SOUND_DESIGN}
            onClick={props.handleMobileMenuClose}
          >
            {process.env.REACT_APP_MKT_SITE_SOUND_DESIGN_LABEL}
          </Link>
        </div>
        <div className="mb-4">
          <Link to={'/new-inspiration'} onClick={props.handleMobileMenuClose}>
            {process.env.REACT_APP_MKT_SITE_INSPIRATION_LABEL}
          </Link>
        </div>
        <div className="mb-4">
         <Link  to={"/catalogs"} onClick={props.handleMobileMenuClose}>
                        <span className={
                               "text-xl "}>
                          CATALOGS
                        </span>
                      </Link>

        </div>
       
        
        {userData === null ? (
          <>
            <div className="mb-4">
              <a href={process.env.REACT_APP_MKT_SITE_PRICING}>
                {process.env.REACT_APP_MKT_SITE_PRICING_LABEL}
              </a>
            </div>
            <Link to={"/signin"} onClick={props.handleMobileMenuClose}>
              <div className="mb-4">SIGN IN</div>
            </Link>
          </>
        ) : (
          <>
            <Link to={"/projects"} onClick={props.handleMobileMenuClose}>
              <div className="mb-4">ACCOUNT</div>
            </Link>
            <div>
              <button className="navPinkbuttonwide" onClick={handleSignoutClick}>
                SIGN OUT
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default MobileMenu;
